import { ReactElement, useEffect, useState } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileMatchcardScreen } from './MobileMatchcardScreen'
import { WebMatchcardScreen } from './WebMatchcardScreen'
import { MatchcardData, useMatchcardStore } from '../../stores/MatchcardStore'
import { NextEventData, useNextEventStore } from '../../stores/NextEventStore'
import { useNavigate, useParams } from 'react-router-dom'
import { SpinnerWrapper } from '../../components/spinner/SpinnerWrapper'
import { ROUTES } from '../../config/routes'

export type MatchcardScreenProps = {
  matches: MatchcardData[]
  announcements: MatchcardData[]
  eventData: NextEventData
  onBackClick: () => void
}

export const MatchcardScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)
  const navigate = useNavigate()
  const { eventSlug } = useParams<{ eventSlug: string }>()

  const navigateUp = (): void => {
    navigate(ROUTES.start)
  }
  const nextEventStore = useNextEventStore()
  const matchcardStore = useMatchcardStore()
  const [eventData, setEventData] = useState<NextEventData>()
  const [matches, setMatches] = useState<MatchcardData[]>([])
  const [announcements, setAnnouncements] = useState<MatchcardData[]>([])

  useEffect(() => {
    if (nextEventStore.loaded) {
      if (eventSlug) {
        setEventData(nextEventStore.getEventData(eventSlug))
      }
    }
  }, [nextEventStore, eventSlug])

  useEffect(() => {
    if (matchcardStore.loaded) {
      if (eventData) {
        const { groupedAnnouncements, groupedMatches } = groupAnnouncements(
          matchcardStore.getMatchcardForEvent(eventData.eventId),
        )
        setMatches(groupedMatches)
        setAnnouncements(groupedAnnouncements)
      }
    }
  }, [matchcardStore, eventData])

  return (
    <SpinnerWrapper loaded={matchcardStore.loaded && nextEventStore.loaded} isMobile={isMobile}>
      {eventData === undefined ? (
        <></>
      ) : isMobile ? (
        <MobileMatchcardScreen
          matches={matches}
          announcements={announcements}
          eventData={eventData}
          onBackClick={navigateUp}
        />
      ) : (
        <WebMatchcardScreen
          matches={matches}
          announcements={announcements}
          eventData={eventData}
          onBackClick={navigateUp}
        />
      )}
    </SpinnerWrapper>
  )
}

function groupAnnouncements(list: MatchcardData[]): {
  groupedAnnouncements: MatchcardData[]
  groupedMatches: MatchcardData[]
} {
  return list.reduce(
    (result, item) => {
      if (item.isWrestler) {
        result.groupedAnnouncements.push(item)
      } else {
        result.groupedMatches.push(item)
      }
      return result
    },
    { groupedAnnouncements: [], groupedMatches: [] } as {
      groupedAnnouncements: MatchcardData[]
      groupedMatches: MatchcardData[]
    },
  )
}
